const IG_STORY_SA_DISPLAY_NAMES = {
  'angel@belleandkate.com': 'Angel - KANA',
  'alvia.cindy@belleandkate.com': 'Cindy - SAM',
  'celia.ramiza.belleandkate@gmail.com': 'Celia - ANYA',
  'yasyifa.pramesti@belleandkate.com': 'Yasyifa - KIKI',
  'debby.aprilia@belleandkate.com': 'Debby - MARTHA',
  'k.nisa@belleandkate.com': 'Nisa - RACHEL',
  'novi@belleandkate.com': 'Novi - TANIA',
  'vanya@belleandkate.com': 'Vanya - VALEN',
  'visa@belleandkate.com': 'Visa - VINA',
  'winny.glory@belleandkate.com': 'Winny - WINONA',
  'maudy.sabrina@belleandkate.com': 'Sabrina - ZARA'
}

export const getIgStorySaDisplayName = (row = {}) => {
  const email = String(row?.email || '').trim().toLowerCase()

  return (
    IG_STORY_SA_DISPLAY_NAMES[email] ||
    row?.display_name ||
    row?.name ||
    row?.email ||
    '-'
  )
}
